import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export const useParallaxAnimal = (bgSelector: string, wrapSelector: string) => {
    const gspTlRef = useRef<ScrollTrigger[]>([]);

    const getElementsAnimal = () => {
        if (!bgSelector || !wrapSelector) {
            return;
        }
        if (gspTlRef.current.length) return; // 已经注册过
        gsap.to(bgSelector, {
            yPercent: -15, // 背景移动速度（正数：随着滚动向下）
            ease: 'none',
            scrollTrigger: {
                trigger: wrapSelector,
                start: 'top 100%', // 容器顶部到达视口底部
                end: 'bottom top',
                scrub: true,
            },
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            getElementsAnimal();
        }

        return () => {
            gspTlRef.current.forEach((st: any) => st.kill());
            gspTlRef.current = [];
        };
    }, []);
};
